"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var padding_1 = require("../padding");
var radio_button_1 = require("../radio-button");
var stack_1 = require("../stack");
function RadioButtonGroup(_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'vertical' : _b, disabled = _a.disabled, label = _a.label, name = _a.name, onChange = _a.onChange, options = _a.options, textColor = _a.textColor, value = _a.value;
    function handleChange(selection) {
        if (onChange) {
            onChange(selection);
        }
    }
    return (react_1.default.createElement(stack_1.Stack, { gap: 2, direction: direction }, options.map(function (option) {
        return (react_1.default.createElement(padding_1.Padding, { bottom: 2, right: 16, key: "".concat(name, "-").concat(option.value) },
            react_1.default.createElement(radio_button_1.RadioButton, { disabled: disabled, isChecked: value === option.value, label: label || option.label, name: name, onChange: function () { return handleChange(option.value.toString()); }, textColor: textColor, value: option.value })));
    })));
}
exports.RadioButtonGroup = RadioButtonGroup;
//# sourceMappingURL=index.js.map